import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import routes from '@/routes';
import LayoutDefault from '@/layouts/Default';
import LayoutEmpty from '@/layouts/Empty';
import Main from '@/pages/Main';
import Settings from '@/pages/Settings';
import Users from '@/pages/Users';
import Reports from '@/pages/Reports';
import Login from '@/pages/Login';
import Error from '@/pages/Error';
import Forgot from '@/pages/ForgotPassword';
import Reset from '@/pages/ResetPassword';
import Agents from '@/pages/Agents';
import AgentsArchived from '@/pages/AgentsArchived';
import Agentview from '@/pages/Agentview';
import Agentcreate from '@/pages/Agentcreate';
import ReportsList from '@/pages/ReportsList';
import ReportsView from '@/pages/ReportsView';
import AgencyCommissions from '@/pages/AgencyCommissions';
import { WithLocationKey } from '@/helpers/route';
import Files from '@/pages/files';
import Import from '@/pages/Imports';
import ManualImport from '@/pages/ManualImports';
import ArchivedExpensesAgent from '@/pages/ViewAgentArchivedExpenses';
import ArchivedFeesAgent from '@/pages/ViewAgentArchiveFees';
import ArchivedEmailsAgent from '@/pages/ViewAgentArchivedEmails';
import MonthlyPayment from '@/pages/MonthlyPayment';
import ViewMonthlyPayment from '@/pages/ViewMonthlyPayment';
import PaymentConfirmation from '@/pages/PaymentConfirmation';
import FileCommissionDeviations from '@/pages/FileCommissionDeviations';
import Events from '@/pages/Events';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<Error />}>
      <Route element={<LayoutDefault />}>
        <Route path={routes.main.path} element={<Main />} />
        <Route path={routes.agencyCommissions.path} element={<AgencyCommissions />} />
        <Route path={routes.settings.path} element={<Settings />} />
        <Route path={routes.imports.path} element = {<Import/>} />
        <Route path={routes.manualImports.path} element = {<ManualImport/>} />
        <Route path={routes.reports.path} element={<Reports />} />
        <Route path={routes.users.path} element={<Users />} />
        <Route path={routes.agents.path} element={<Agents />} />
        <Route path={routes.files.path} element={<Files />} />
        <Route path={routes.agentsArchived.path} element={<AgentsArchived />} />
        <Route path={routes.reportList.path} element={<ReportsList />} />
        <Route
         path={routes.reportsView.path}
         element={ <WithLocationKey>
         {(key) => <ReportsView key={key} />}
         </WithLocationKey>
         }/>
        <Route path={routes.agentView.path} element={<Agentview />} />
        <Route path={routes.agentCreate.path} element={<Agentcreate />} />
        <Route path={routes.archiveExpenses.path} element={<ArchivedExpensesAgent />} />
        <Route path={routes.archiveFees.path} element={<ArchivedFeesAgent />} />
        <Route path={routes.archiveEmails.path} element={<ArchivedEmailsAgent />} />
        <Route path={routes.monthlyPayment.path} element={<MonthlyPayment />} />
        <Route path={routes.viewMonthlyPayment.path} element={<ViewMonthlyPayment />} />
        <Route path={routes.paymentConfirm.path} element={<PaymentConfirmation />} />
        <Route path={routes.fileCommissionDeviations.path} element={<FileCommissionDeviations />} />
        <Route path={routes.events.path} element={<Events />} />

      </Route>
      <Route element={<LayoutEmpty />}>
        <Route path={routes.login.path} element={<Login />} />
        <Route path={routes.forgot.path} element={<Forgot />} />
        <Route path={routes.reset.path} element={<Reset />} />
      </Route>
    </Route>,
  ),
);

export default router;
